import { useRef } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { Search, Check2Square, List, DashCircle } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { getUserList, setUserPop } from "../store/api/Users";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalSelectUser = () => {
    const userList = useSelector(state => state.UserReducer.userList);
    const popStatus = useSelector(state => state.UserReducer.userPop);
    const searchData = useRef({});
    const selectedIDs = useRef([]);
    const dispatch = useDispatch();
    const search = () => {
        dispatch(getUserList(searchData.current.Name));
    }
    const setSelectedIDs = (add, id) => {
        if (add) {
            selectedIDs.current.push(id);

        }
        else {
            let indx = selectedIDs.current.indexOf(id);
            selectedIDs.current.splice(indx, 1);
        }
    }
    const select = () => {
        if (selectedIDs.current.length > 0) {
            if (popStatus.selectUser) {
                popStatus.selectUser(selectedIDs.current);

            }
            else if (popStatus.selectOneUser) {
                const userID = selectedIDs.current.pop();
                const user = userList.find(u => u.ID === userID);
                popStatus.selectOneUser(user);
            }
            else if (popStatus.selectUsersWithName) {
                const selectedUsers = userList.filter(ul => selectedIDs.current.find(i => i === ul.ID));
                popStatus.selectUsersWithName(selectedUsers);
            }
        }
        selectedIDs.current = [];
        dispatch(setUserPop({ show: false }));
    }
    const cancel = () => {
        if (popStatus.selectUser) {
            popStatus.selectUser([]);

        }
        else if (popStatus.selectOneUser) {
            popStatus.selectOneUser({});
        }
        else if (popStatus.selectUsersWithName) {
            popStatus.selectUsersWithName(null);
        }
        dispatch(setUserPop({ show: false }));
    }
    return (
        <Modal show={popStatus.show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle"><span><List color="white" size={22} />&nbsp;لیست کاربران</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => dispatch(setUserPop({ show: false }))} style={{ cursor: "pointer" }} /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group">
                    <input type="text" className="form-control" placeholder="نام کاربر" onChange={e => searchData.current.Name = e.target.value} />
                    <Button className="btn-input" onClick={search} style={{ top: 3, left: 3 }}><Search size={17} /></Button>
                </div>
                <hr style={{ marginBottom: 0 }} />
                {userList &&
                    <div className="mt-1 scThin" style={{ maxHeight: "350px", overflowX: "hidden", overflowY: "auto" }}>
                        <Table >
                            <thead>
                                <tr>
                                    <th style={{ width: "10px", padding: "0" }}></th>
                                    <th style={{ padding: "0" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(userList ?? "") && userList.map((item, i) => {
                                    return (
                                    <tr key={i} className="resultTableRow">
                                        <td><input type="checkbox" className="form-check-input" onChange={(e) => setSelectedIDs(e.target.checked, item.ID)} /></td>
                                        <td>{item.Name}</td>
                                    </tr>)
                                }
                                )}
                            </tbody>
                        </Table>
                    </div>
                }
                <div className="mt-2">
                    <Button className="btn-success group-Btn" onClick={select}><Check2Square size={14} /> انتخاب کاربر</Button>
                    <Button variant="danger" className="group-Btn" onClick={cancel}><DashCircle size={14} /> انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectUser;